import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { deactivationNoteSummary } from '~/models/modules/deactivationNote';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class DeactivationNotesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    getAllNotes() {
        return this.http.get<deactivationNoteSummary[]>(this._url());
    }

    getNotesByPage(page: string) {
        return this.http.get<deactivationNoteSummary[]>(this._url(`/${page}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/DeactivationNotes${v}`);
    }
}
